"use client";

import { cn } from "../../lib";
import { IntentProgressBar } from "../intent-ui/progress-bar";
import { clampMediaPlayerPlayheadPercent } from "./media-player-playhead";
import type { MediaPlayerTheme } from "./media-player-theme";
import { MediaPlayerTrackGlow } from "./media-player-track-glow";

export interface MediaPlayerStaticProgressTrackProps {
	theme: MediaPlayerTheme;
	progressPercent: number;
	trackGlow?: boolean;
	cardLayout?: "narrow" | "wide";
	ariaLabel?: string;
	className?: string;
}

/** Non-scrubbing card autoplay track: progress fill + optional aurora overlay. */
export function MediaPlayerStaticProgressTrack({
	theme,
	progressPercent,
	trackGlow = true,
	ariaLabel = "Card autoplay progress",
	className,
}: MediaPlayerStaticProgressTrackProps) {
	const playheadPercent = clampMediaPlayerPlayheadPercent(progressPercent);

	return (
		<div
			className={cn(
				"relative w-full",
				trackGlow && "flex min-h-11 items-center overflow-visible py-2",
				className,
			)}
		>
			<IntentProgressBar
				className={cn(
					"relative z-[1] w-full",
					trackGlow && "[&>div]:h-2.5",
					"[&>div]:!rounded-full",
				)}
				value={progressPercent}
				animateIndicator={false}
				trackClassName={theme.trackClassName}
				indicatorClassName={theme.indicatorClassName}
				trackOverlay={
					trackGlow ? (
						<MediaPlayerTrackGlow
							playheadPercent={playheadPercent}
							color1={theme.trackGlowColor1}
							color2={theme.trackGlowColor2}
							className="-top-4 -bottom-4"
						/>
					) : undefined
				}
				aria-label={ariaLabel}
			/>
		</div>
	);
}
